import { render } from "./ValueSection.vue?vue&type=template&id=7b742ed1&scoped=true&ts=true"
import script from "./ValueSection.vue?vue&type=script&lang=ts"
export * from "./ValueSection.vue?vue&type=script&lang=ts"

import "./ValueSection.vue?vue&type=style&index=0&id=7b742ed1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b742ed1"]])

export default __exports__